export class ProjectRole {
  constructor(
    public projectId: string,
    public role: 'PI' | 'RESEARCHER' | 'NONE',
  ) {}
}
